import React from 'react'
import { SettingsBox } from 'src/Elements/Data'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useApp } from 'src/Hooks'
import { NumberField } from 'src/Libs/inputs/react-hook-form'
import { DynamicTariffSettingsFormFields } from 'src/Libs/dynamic-tariff-settings/constants'
import { UnitTypes } from 'src/Libs/types'

interface Props {
  hasWritingRights: boolean
}

/**
 * Field to show and edit the VAT percentage of dynamic tariff settings form
 */
const VatPercentField: React.FC<Props> = ({ hasWritingRights }) => {
  const { t } = useCustomTranslation()
  const { isMobile: isDownSm } = useApp()

  const suffix = (
    <NumberField
      disabled={!hasWritingRights}
      sx={{ ...(isDownSm ? { width: '100%' } : { maxWidth: theme => theme.spacing(25) }) }}
      name={DynamicTariffSettingsFormFields.VatPercent}
      suffix={UnitTypes.percentage}
      inputProps={{ style: { textAlign: 'right' } }}
      fullWidth
    />
  )

  return <SettingsBox title={t('dynamic-tariff-settings.dynamic-power-price.vatPercent')} suffix={suffix} disabled={!hasWritingRights} />
}

export default VatPercentField
